import { createStore, StoreOptions } from "vuex";
import { RootState } from "./type";
import user from "./modules/user";
import route from "./modules/route";
import entity from "./modules/entity";

const storeOptions: StoreOptions<RootState> = {
  modules: {
    user,
    route,
    entity,
  },
};
export default createStore<RootState>(storeOptions);
